import { useContext } from "react";
import { ThemeContext } from "../ThemeContext";

const useThemeContext = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error(
      "useThemeContext must be used within a ThemeProviderWrapper",
    );
  }
  return context;
};

export default useThemeContext;
